export const shouldShowAmbientLegend = ({activeSection, ambient, blocked = false}) => {
  return activeSection === 'ambients' && ambient != null && !blocked
}

export const shouldRenderMapLegends = ({
  isLandRoute,
  hasComparisonLegends,
  shouldShowBasicLegend,
  showAmbientLegend,
}) => Boolean(
  isLandRoute && (hasComparisonLegends || shouldShowBasicLegend || showAmbientLegend)
)
